// Source
import * as HelperSrc from "../HelperSrc";

export default class StoreLocalization<T> {
    storageSet = (value: T): void => {
        HelperSrc.writeStorage<T>("localization", value);

        HelperSrc.storageDispatchEvent("localization");
    };

    storageGet = (): T | undefined => {
        return HelperSrc.readStorage<T>("localization");
    };

    storageRemove = (): void => {
        HelperSrc.removeStorage("localization");
    };
}
